// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"e39fb86cecc33b37c2de","966":"22f60e73a77093f1f1a2"}[chunkId] + ".js";
};